var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHairLossFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 51.12C20.1099 51.12 15.4299 50.12 12.4499 47.81C11.3099 46.91 9.13988 48.59 7.31988 46.12C4.88988 42.83 5.73988 39.46 7.40988 38.56C9.40988 37.48 11.1499 39.77 11.1499 39.77C8.19988 23.04 14.9999 12.71 29.9999 12.71C44.9999 12.71 51.7999 23.04 48.8499 39.77C48.8499 39.77 50.5999 37.48 52.5899 38.56C54.2599 39.46 55.1099 42.83 52.6799 46.12C50.8599 48.59 48.6799 46.91 47.5499 47.81C44.5699 50.15 39.8899 51.12 29.9999 51.12Z",
    fill: "#FFE2C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12.71C45 12.71 51.8 23.06 48.85 39.77C47.07 37.56 45.93 35.77 45.58 31.24C45.5002 29.9039 44.9846 28.6309 44.1123 27.6158C43.2399 26.6008 42.0588 25.8997 40.75 25.62C37.22 24.95 34.24 25.81 30 25.81C25.76 25.81 22.77 24.95 19.25 25.62C17.9415 25.8985 16.7608 26.5996 15.8898 27.6151C15.0189 28.6306 14.5059 29.9043 14.43 31.24C14.07 35.82 12.93 37.56 11.15 39.77C8.19999 23.04 15 12.71 30 12.71Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairLossFill);
export default __webpack_public_path__ + "static/media/hair-loss-fill.21e46af37062618201b28011813afef5.svg";
export { ForwardRef as ReactComponent };